import React from "react";
import { observer } from "mobx-react-lite";
import { useStore } from "../../Store";

const AbroadProccessInfo = () => {
  const { casesStore } = useStore();
  const link = casesStore.presentation?.abroadInfoLink;
  if (!link) return null;

  return (
    <div className="margin--right-10 margin--top-20 text-link">
      <a href={link}>Read more about the process for roadside assistance abroad.</a>
    </div>
  );
};

export default observer(AbroadProccessInfo);
